import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from "src/environments/environment"
import { FixCat } from "./fixcat"
import { HttpClient, HttpHeaders } from "@angular/common/http"
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FixCatService {
  fixUrl = environment.appURL + "/fixcats"
  constructor(private http: HttpClient) {
  }

  // GET ALL CATEGORIES
  getCats() {
    return this.http.get<FixCat[]>(this.fixUrl, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) })
      .pipe(tap(_ => { }), catchError(this.handleError('getCats', [])));
  }

  // GET CATEGORY BY ID
  getCat(id: number) {
    const url = `${this.fixUrl}/${id}`;
    return this.http.get<FixCat>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) })
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<FixCat>(`getFixCat id=${id}`))
      );
  }


  // UPDATE CATEGORY
  updateCat(cat: FixCat): Observable<any> {
    let upd = "cat=" + cat.cat;
    return this.http.put(this.fixUrl + "/" + cat.id, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/x-www-form-urlencoded" }) })
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('updateCat'))
      );
  }


  // ERROR HANDLER
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}